<template>
  <v-list-group
    v-model="open"
    :sub-group="subGroup"
  >
    <template #activator>
      <v-list-item-action
        v-if="! subGroup"
        class="my-1"
      >
        <h-badged-avatar
          icon="sellingFormat"
          :resource="item"
        />
      </v-list-item-action>
      <v-list-item-content>
        <v-list-item-title :class="subGroup ? 'text-body-2 pl-6' : ''">
          {{ item.name }}
          <v-icon
            v-if="subGroup"
            small
            right
            color="primary"
            v-text="icons.sellingFormat"
          />
        </v-list-item-title>
      </v-list-item-content>
    </template>
    <h-item
      v-for="(sellingFormat, i) in sellingFormatItems(item.id)"
      :key="i"
      :item="sellingFormat"
      :count="count(sellingFormat)"
      dense
      class="pl-8"
      @click="clicked(sellingFormat)"
    />
    <!-- COMBINATIONS -->
    <v-dialog
      :value="combinationsDialog"
      scrollable
      persistent
    >
      <v-card tile light>
        <v-toolbar
          flat
          color="grey lighten-4"
        >
          <v-btn
            icon
            color="primary"
            @click.stop="combinationsDialog = false"
          >
            <v-icon v-text="icons.close" />
          </v-btn>
          <v-spacer />
          <v-toolbar-title v-text="item.name" />
          <v-spacer />
        </v-toolbar>
        <v-divider />
        <v-card-text class="px-0">
          <v-list>
            <h-combination
              v-for="combination in combinations"
              :key="combination.id"
              :combination="combination"
              @select="combine"
            />
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- MODIFIERS -->
    <h-modifiers
      v-model="modifiers"
      @complete="addItemWithModifiers"
    />
  </v-list-group>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import ChecksMinQuantity from '@/Mixins/ChecksMinQuantity'
  import UsesIcons from '@/Mixins/UsesIcons'
  import HBadgedAvatar from '@/Components/BadgedAvatar'
  import HModifiers from '@/Sections/Order/Modifiers/Dialog'
  import HItem from './Item'
  import HCombination from './Combination'

  export default {
    mixins: [
      ChecksMinQuantity,
      UsesIcons,
    ],

    components: {
      HBadgedAvatar,
      HModifiers,
      HItem,
      HCombination,
    },

    props: {
      item: {
        required: true,
        type: Object,
      },
      disabled: {
        required: false,
        type: Boolean,
        default: false,
      },
      subGroup: {
        required: false,
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      open: false,
      formattedItem: {},
      combinations: [],
      combinationsDialog: false,
      modifiers: false,
    }),

    computed: {
      ...mapGetters('catalog', [
        'sellingFormatItems',
        'sellingFormatPivot',
        'sellingFormatCombinations',
        'showModifiers',
      ]),
    },

    watch: {
      open (v) {
        if (v) {
          this.$emit('unfold')
        }
      },
    },

    methods: {
      count (sellingFormat) {
        return this.$store.getters['orders/itemCounter']({
          item_id: this.item.id,
          format_id: sellingFormat.id,
        })
      },
      ...mapActions('orders', [
        'addItem',
        'addItemWithModifiers',
      ]),
      clicked (sellingFormat) {
        if (this.disabled) {
          return
        }
        this.checkMinQuantity(this.item)
        this.setFormattedItem(sellingFormat)
        if (this.combinations.length) {
          this.combinationsDialog = true
          return
        }
        this.picked()
      },
      combine (combination) {
        this.combinationsDialog = false
        this.formattedItem.combination = combination
        this.picked()
      },
      picked () {
        if (this.showModifiers(this.item)) {
          this.openModifiers()
          return
        }
        this.addItem(this.formattedItem)
      },
      setFormattedItem (sellingFormat) {
        const pivot = this.sellingFormatPivot({
          item_id: this.item.id,
          format_id: sellingFormat.id,
        })
        this.formattedItem = {
          ...this.item,
          price: pivot.price,
          sellingFormatPivotId: pivot.id,
          combination: null,
        }
        this.combinations = this.sellingFormatCombinations(pivot.combination_group_id)
      },
      openModifiers () {
        this.$store
          .dispatch('orders/modifiers/init', { item: this.formattedItem })
          .then(() => this.modifiers = true)
      },
    },
  }
</script>
